module.exports = __webpack_public_path__ + "static/media/AdmisionesCriticas.d22ca518.svg";